<h1 mat-dialog-title>
  <p>{{ 'users.selectUsers' | t }}</p>
  <form class="search-bar" (ngSubmit)="submitForm()">
    <input [placeholder]="'common.search' | t" [formControl]="searchControl" />
    <sn-icon-button
      icon="search"
      type="submit"
      [matTooltip]="'common.search' | t"
      class="sn-searchbar__search-button"
    >
    </sn-icon-button>
    <sn-icon-button
      icon="close"
      [matTooltip]="'common.clearSearch' | t"
      class="sn-searchbar__clear-button"
      (click)="clear()"
    >
    </sn-icon-button>
  </form>
</h1>
<mat-dialog-content>
  <sn-data-list #list [fetchFn]="loadData">
    <sn-infinite-scroll>
      <sn-pull-to-refresh>
        <ng-template [ngIf]="list.dataSource.data.length" [ngIfThen]="listTmpl"></ng-template>
        <ng-template
          [ngIf]="!list.dataSource.data.length && list.dataIsInited"
          [ngIfThen]="emptyTmpl"
        ></ng-template>
      </sn-pull-to-refresh>
    </sn-infinite-scroll>
  </sn-data-list>
</mat-dialog-content>
<mat-dialog-actions snButtonGroup>
  <button mat-button color="danger" (click)="cancel()">{{ 'common.cancel' | t }}</button>
  <button mat-button color="success" (click)="call()">{{ 'users.policyGroups.manageFormActionsAddUsers' | t }}</button>
</mat-dialog-actions>

<ng-template #listTmpl>
  <mat-table [dataSource]="list.dataSource.data">
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
        >
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
        >
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="firstName">
      <mat-header-cell *matHeaderCellDef>{{ 'common.firstName' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let user">
        {{ user.firstName }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="lastName">
      <mat-header-cell *matHeaderCellDef>{{ 'common.lastName' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let user">
        {{ user.lastName }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef>{{ 'common.email' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let user">
        {{ user.email }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="lastLogin">
      <mat-header-cell *matHeaderCellDef>{{ 'common.lastActive' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let user">
        <sn-user-last-active [user]="user"></sn-user-last-active>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
    <mat-row (click)="selection.toggle(user)" *matRowDef="let user; columns: columns"> </mat-row>
  </mat-table>
</ng-template>

<ng-template #emptyTmpl>
  <sn-empty-state icon="cancel_presentation" [title]="'common.noResults' | t">
    {{ 'common.noResultsMatchSearch' | t }}
  </sn-empty-state>
</ng-template>
